import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { HERO_OUTLINE }         from '../../../../shared/constants/heroOutline.js'
import { PRODUCT_PREVIEW_KIND } from '../../../../shared/constants/productPreviewMode.js'

import { Button }   from '../../../../shared/ui/Button/index.js'
import { DataItem } from '../../../../shared/ui/DataItem/DataItem.jsx'

import styles from './OutlinePreview.module.scss'

/**
 * OutlinePreview — popover content for building/tier outline hover in VisualizationView.
 *
 * Renders a small card with:
 * - Type label (buildings / tiers)
 * - Name
 * - Apartment count (filtered/total or just total when no filters active)
 * - CTA button triggering navigation
 *
 * @param {object}   props
 * @param {string}   [props.buildingLabel]
 * @param {string}   [props.buildingName]    — parent building name (tier only)
 * @param {string}   props.countLabel
 * @param {string}   props.countValue
 * @param {string}   props.ctaText
 * @param {boolean}  [props.hasFilters]      — true when at least 1 filter active
 * @param {boolean}  props.isBuilding
 * @param {string}   props.label
 * @param {string}   props.name              — display name of building or tier
 * @param {() => void} [props.onAction]      — CTA click handler
 * @param {boolean}  [props.showCta=true]    — show CTA button when true and onAction provided
 */
export function OutlinePreview({
  buildingLabel,
  buildingName,
  countLabel,
  countValue,
  ctaText,
  hasFilters,
  isBuilding,
  label,
  name,
  onAction,
  showCta = true,
  className
}) {

  const rootClass = [styles.holder, className].filter(Boolean).join(' ')

  return (
    <div className={rootClass}>
      <div className={styles.dataPanel}>
        <div className={styles.dataGridContainer}>
          {!isBuilding && buildingName && (
            <DataItem 
              label={buildingLabel} 
              value={buildingName} 
            />
          )}
          <DataItem label={label} value={name} />
          <DataItem label={countLabel} value={countValue} />
        </div>

        {showCta && onAction && (
        <div className={styles.ctaBox}>
          <Button 
            type="button"
            kind="wide"
            size="large"
            cta
            // className={styles.cta} 
            onClick={onAction}
          >
            {ctaText}
          </Button>
        </div>
        )}
      </div>
      {/* 
        place for second thumbnail column
      */}
    </div>
  )
}
